export default "__VITE_ASSET__ff249416__"